module.exports = __webpack_public_path__ + "img/11.30c8a2b2.png";